// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/HeaderPanel/HeaderPanel.less
// module id = 1143
// module chunks = 0